import Grade from './grade';
import Gender from './gender';
import Image from './Image';
import VIP from './vip';
import OfficialAuth from './official-auth';

module.exports  = {
	Grade: Grade,
	Gender: Gender,
	ImageView: Image,
	VIP: VIP,
	OfficialAuth: OfficialAuth
}



// WEBPACK FOOTER //
// ./js/component/user-ui/index.js